var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type } from "./decorators/type.js";
import { Vector2dSchema } from "./utils/vector.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let PlayerInputSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "keyMap");
    __publicField(this, "mousePosition");
    __publicField(this, "buttons");
    __publicField(this, "prevKeyMap");
    __publicField(this, "id");
    __publicField(this, "name");
    __publicField(this, "events");
  }
};
__decorateClass([
  type("object")
], PlayerInputSchema.prototype, "keyMap", 2);
__decorateClass([
  type(Vector2dSchema)
], PlayerInputSchema.prototype, "mousePosition", 2);
__decorateClass([
  type("number")
], PlayerInputSchema.prototype, "buttons", 2);
__decorateClass([
  type("object")
], PlayerInputSchema.prototype, "prevKeyMap", 2);
__decorateClass([
  type("string")
], PlayerInputSchema.prototype, "id", 2);
__decorateClass([
  type("string")
], PlayerInputSchema.prototype, "name", 2);
__decorateClass([
  type(["string"])
], PlayerInputSchema.prototype, "events", 2);
PlayerInputSchema = __decorateClass([
  Component("PlayerInput")
], PlayerInputSchema);
const __vite_glob_0_6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get PlayerInputSchema() {
    return PlayerInputSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  PlayerInputSchema as P,
  __vite_glob_0_6 as _
};
//# sourceMappingURL=PlayerInput-ad722e2d.js.map
